const { registerBlockType } = wp.blocks;

import Edit from "./Edit";
// import Save from "./Save";

import metadata from "./../../../blocks/audioplayer/block.json";

registerBlockType(metadata, {
  edit: Edit,
  save: () => null,
  getEditWrapperProps: () => {
    return {
      className: "h5ap-block-wrapper",
    };
  },
});
